import BoardPostsPage from './BoardPostsPage';

export const boardPostsRoutes = [
  {
    path: '',
    element: <BoardPostsPage />,
  },
];
